
const env = {
  NANGO_API_URL: process.env.REACT_APP_NANGO_API_URL,
  API_URL: process.env.REACT_APP_API_URL,
  API_ENV: process.env.REACT_APP_API_ENV,
  FACEBOOK_AUTH: process.env.REACT_APP_FACEBOOK_AUTH,
  GDriveURL: process.env.REACT_APP_GDRIVE_URL,
  MONDAY_URL: process.env.REACT_APP_MONDAY_URL,
  TEAMS_URL: process.env.REACT_APP_TEAMS_URL,
  NANGO_API_HOST: process.env.REACT_APP_NANGO_API_HOST,
  NANGO_CONNECT_UI_HOST: process.env.REACT_APP_NANGO_CONNECT_UI_HOST
};

export default env;
